import { defineComponent, h, useAttrs } from 'vue'
import { VPagination } from 'vuetify/components'

VPagination.compatConfig = {
  ...(VPagination.compatConfig || {}),
  COMPONENT_V_MODEL: false
}

function normalizeAttrs(attrs) {
  const normalized = { ...attrs }
  normalized.modelValue = attrs.modelValue ?? attrs.value
  delete normalized.value
  return normalized
}

export default defineComponent({
  name: 'VPaginationCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,
  emits: ['update:modelValue', 'input'],

  setup(_, { emit, slots }) {
    const attrs = useAttrs()

    return () =>
      h(
        VPagination,
        {
          ...normalizeAttrs(attrs),
          'onUpdate:modelValue': (value) => {
            emit('update:modelValue', value)
            emit('input', value)
          }
        },
        slots
      )
  }
})
